//
import PosPendingSaleModel from '@/models/POS/PosPendingSale'

/**
 * 
 */
export default class PosPendingSale {

  /**
   * 
   */
  static cancel() {

    //
    const posPendingSale = this.model().from()

    //
    return posPendingSale.request({
      url: `${ posPendingSale.baseURL() }/pending_pos_sales`,
      method: 'delete',
    })
  }
  /**
   * 
   */
  static cancelEmployee() {

    //
    const posPendingSale = this.model().from()

    //
    return posPendingSale.request({
      url: `${ posPendingSale.baseURL() }/pending_pos_employee_sales`,
      method: 'delete',
    })
  }

  /**
   * 
   */
  static model() {
    return PosPendingSaleModel
  }
}